var map = {
	"./biaozhun.svg": "f732",
	"./caiwu.svg": "7f54",
	"./diyutese.svg": "7951",
	"./guihuasheji.svg": "e459",
	"./huanbaolvhua.svg": "cbed",
	"./kejifuwu.svg": "4b43",
	"./peixun.svg": "45dd",
	"./pinpai.svg": "5782",
	"./qiyezhiliangguanli.svg": "2ea2",
	"./ruanjiandinzhi.svg": "4a59",
	"./sheji.svg": "f797",
	"./yanjiubaogao.svg": "e65a",
	"./zhiliang.svg": "31bd",
	"./zhuanli.svg": "5c4e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";